'use client';

import { type ElementType } from 'react';
import {
  Autocomplete as MUIAutocomplete,
  AutocompleteProps,
  type ChipTypeMap,
} from '@mui/material';

export { type AutocompleteProps, type ChipTypeMap } from '@mui/material';

export function Autocomplete<
  Value,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends ElementType = ChipTypeMap['defaultComponent'],
>(
  props: AutocompleteProps<
    Value,
    Multiple,
    DisableClearable,
    FreeSolo,
    ChipComponent
  >,
) {
  return <MUIAutocomplete {...props} />;
}
